export default __webpack_public_path__ + "static/media/tear.42d6cec6.88448042.svg";